var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-modal-input',{attrs:{"title":_vm.Info.Dialog.EditSellPrice.Title,"width":500},on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('kst-input',{ref:"txtSellPrice_Edit",attrs:{"field":"SellPrice","data":_vm.editData,"catalog":_vm.PosItemCatalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }